import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 20px 0 0;
  display: flex;
  flex-wrap: wrap;
  min-width: 0;
  gap: 30px;
`;
